import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Challenge2026AndroidWrapper } from '../commonAndroidWrapper/Challenge2026AndroidWrapper';
import { MyDashboardStepsLoader } from '../../../components/challenge/challengeMyDashboard';
import ImageCard2026Challenge from '../myImageCard/ImageCard2026Challenge';
import { AFTER_TYPE, getPhotoName, IMAGE_UPLOAD_LOADING_STATE, PHOTOS_LIST } from '../../challengeConstants';
import './AfterImageCard.scss';

function AfterImageCard({
  eventId,
  redirectionEventIdQuery,
  partyId,
  userId,
  aboId,
  isValidDurationForUpload,
  imagesUploaded,
}) {
  const imageRef = useRef(null);
  const androidFeatureRef = useRef(null);
  const [photos, setPhotos] = useState({
    after_left: null,
    after_center: null,
    after_right: null,
  });
  const [photosLoading, setPhotosLoading] = useState(IMAGE_UPLOAD_LOADING_STATE);
  const { uploadedRes, imagesData } = useSelector((state) => state.challengeImageUpload);

  useEffect(() => {
    const onMountHandler = androidFeatureRef?.current?.onMountHandler;
    if (onMountHandler) 
    {onMountHandler(uploadedRes);}
  }, [uploadedRes]);


  const loadGreenOrGreyIdleImages = (photo) => {
    if (!isValidDurationForUpload) {
      return `${photo}_grey`; 
    }

    return photo;
  }


  return <div className="image-list-container">
    <Challenge2026AndroidWrapper
      eventId={eventId}
      partyId={partyId}
      aboId={aboId}
      userId={userId}
      redirectionEventIdQuery={redirectionEventIdQuery}
      ref={androidFeatureRef}
      imageRef={imageRef}
      photos={photos}
      setPhotos={setPhotos}
      setPhotosLoading={setPhotosLoading}
      componentInstance={'PICTURE_COMPONENT'}
    />
    <div className="image-list-body">
      {[AFTER_TYPE].map((type) => (
        <div className="image-list-row" key={type}>
          <div className="image-list-image-container">
            {PHOTOS_LIST.map((photo, idx) => (
              <React.Fragment key={`${idx}_${getPhotoName(type, photo)}`}>
                {photosLoading[getPhotoName(type, photo)] ? (
                  <MyDashboardStepsLoader className="image-list-image-single image-list-image-uploaded" />
                ) : (
                  <ImageCard2026Challenge
                    type={type}
                    photo={photo}
                    handleImageUpload={androidFeatureRef?.current?.handleImageUpload}
                    photos={photos}
                    loadGreenOrGreyIdleImages={loadGreenOrGreyIdleImages}
                    isValidDurationForUpload={isValidDurationForUpload}
                    uploaded={imagesUploaded}
                    isImageUploaded={Boolean(
                      photos[getPhotoName(type, photo)]
                    )}
                  />
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>;
}

export default AfterImageCard;
